// Passenger Info Types

export enum PassengerType {
  ADULT = 'ADT',
  CHILD = 'CHD',
  INFANT = 'INF',
}
export enum PassengerTypeKey {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT = 'INFANT',
}
export enum TitlePrefix {
  MR = 'MR',
  MRS = 'MRS',
  MS = 'MS',
  MSTR = 'MSTR',
  MISS = 'MISS',
}

export enum DocumentType {
  NONE = 'NONE',
  CITIZEN_ID = 'CCCD',
  PASSPORT = 'PASSPORT',
}

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export interface PassengerFormData {
  id: string | number;
  type: PassengerType;
  passengerType: 'ADT' | 'CHD' | 'INF' | 'ADULT' | 'CHILD' | 'INFANT';
  title: string | null;
  // Biệt danh / Nickname (optional) - used for header display as BIỆT DANH
  nickname?: string;
  lastName: string;
  firstName: string;
  dateOfBirth: string | null;
  guardianId?: string | null;
  guardian?: number;
  documentType: DocumentType | string;
  documentNumber?: string;
  citizenId?: string;
  passportNumber?: string;
  nationality?: string;
  issuedPlace?: string;
  expiryDate?: string | null;
  gender?: Gender | string | null;
}

export interface ContactFormData {
  fullName?: string;
  name?: string;
  email: string;
  countryCode: string;
  phoneNumber?: string;
  phone?: string;
}

export interface PassengerInfoState {
  passengers: PassengerFormData[];
  contact: ContactFormData;
  acceptedTerms: boolean;
}

export interface ValidationError {
  field: string;
  message: string;
}

export interface CountryOption {
  code: string;
  name: string;
  dialCode: string;
  flag?: string;
}

// Error messages
export const ERROR_MESSAGES = {
  MSG005: 'Trường này là bắt buộc',
  MSG011: 'Lỗi hệ thống, vui lòng thử lại sau',
  MSG012: 'Số điện thoại phải từ 8 đến 15 ký tự',
  MSG014: 'CCCD phải có đúng 12 ký tự số',
  MSG015: 'Số hộ chiếu phải từ 6 đến 9 ký tự',
  MSG016: 'Hộ chiếu phải còn hạn ít nhất 6 tháng từ ngày bay',
};

// Title options by passenger type
export const TITLE_OPTIONS = {
  [PassengerType.ADULT]: [
    { value: TitlePrefix.MR, label: 'Ông (MR)' },
    { value: TitlePrefix.MRS, label: 'Bà (MRS)' },
    { value: TitlePrefix.MS, label: 'Cô (MS)' },
  ],
  [PassengerType.CHILD]: [
    { value: TitlePrefix.MSTR, label: 'Bé trai (MSTR)' },
    { value: TitlePrefix.MISS, label: 'Bé gái (MISS)' },
  ],
  [PassengerType.INFANT]: [
    { value: TitlePrefix.MSTR, label: 'Em bé trai (MSTR)' },
    { value: TitlePrefix.MISS, label: 'Em bé gái (MISS)' },
  ],
};

export const DOCUMENT_TYPE_OPTIONS = [
  { value: DocumentType.NONE, label: 'Không có' },
  { value: DocumentType.CITIZEN_ID, label: 'CCCD' },
  { value: DocumentType.PASSPORT, label: 'Hộ chiếu' },
];

export const GENDER_OPTIONS = [
  { value: Gender.MALE, label: 'Nam' },
  { value: Gender.FEMALE, label: 'Nữ' },
];

// Alias for backward compatibility
export type PassengerData = PassengerFormData;

// Alias for backward compatibility
export type ContactInfo = ContactFormData;
export type ContactData = ContactFormData;

export interface FlightSegment {
  origin: string;
  originCode: string;
  destination: string;
  destinationCode: string;
  departureTime: string;
  arrivalTime: string;
  flightNumber: string;
  duration: number;
  terminal?: string;
  arrivalTerminal?: string;
}

export interface FlightInfoData {
  outbound: FlightSegment;
  returnFlight?: FlightSegment;
  tripType: 'oneway' | 'roundtrip';
  cabin: string;
  priceDelta: number;
}

export interface TicketInfoData {
  name: string;
  imageUrl: string;
  quantity: number;
  siteCode: string;
  siteName: string;
}

export interface PricingInfo {
  adults: number;
  children: number;
  infants: number;
  pricePerPerson: number;
  totalPrice: number;
}
